import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Organization } from 'src/app/models/organization';
import { EntityFormComponent } from 'src/app/util/entity-form.base';
import { Place, regionMap } from 'src/app/util/geography';
import {
  AdditionalFormData,
  OrganizationForm,
  OrganizationFormService,
} from '../../organization-form.service';

@Component({
  selector: 'app-organization-form',
  templateUrl: './organization-form.component.html',
  styleUrls: ['./organization-form.component.scss'],
})
export class OrganizationFormComponent
  extends EntityFormComponent<
    Organization,
    OrganizationForm,
    AdditionalFormData
  >
  implements OnInit
{
  // Maps available countries
  countries$: Observable<Place[]> = this.formService.additionalFormData$.pipe(
    map(({ countries }) => countries)
  );
  regions$: Observable<Place[]>;

  constructor(formService: OrganizationFormService) {
    super(formService);
  }

  ngOnInit() {
    // Updates the selectable regions when the country is updated
    this.regions$ = this.form.get('country').valueChanges.pipe(
      startWith(this.form.get('country').value),
      map((value) => {
        return Object.entries(regionMap[value] || {}).map((e) => ({
          code: e[0],
          name: e[1],
        }));
      })
    );
  }
}
